import { render, staticRenderFns } from "./JudgeActionCardView.vue?vue&type=template&id=0e61b113&scoped=true&"
import script from "./JudgeActionCardView.vue?vue&type=script&lang=js&"
export * from "./JudgeActionCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61b113",
  null
  
)

export default component.exports